import { useMutation, useQueryClient } from "react-query";
import { AuthContext } from "../../Context/AuthContext";
import { useContext } from "react";

const createCategory = async (categoryData, token) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/categories/createcategory`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(categoryData),
    }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to create category");
  }

  return response.json();
};

const useCreateCategory = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext);

  return useMutation((categoryData) => createCategory(categoryData, token), {
    onSuccess: () => {
      queryClient.invalidateQueries("userCategories");
    },
  });
};

export default useCreateCategory;
